import React from 'react';
import PropTypes from 'prop-types';
import ConnectionsGrid from 'shared/connectionsGrid/ConnectionsGrid';
import BootstrapCard from 'shared/components/bootstrapCard/BootstrapCard';

class ConnectionsOperations extends React.Component {
  componentDidMount(){
    this.props.connectionsActions.fetchConnections();
  }

  handleNewButton = () => this.props.handleNewButton();

  handleEditConnection = connectionId => this.props.connectionsActions.fetchConnection(connectionId);

  render() {
    const { connections, fetchingConnections } = this.props;
    return(
      <BootstrapCard title="" width={ '100%' } titleButtons={ [{ label: "NEW", onClick: this.handleNewButton }] }>
        <ConnectionsGrid
          connectionsListGridData={ connections }
          fetchingConnections={ fetchingConnections }
          showMoreActionsIcon={ false }
          onEditConnection={ this.handleEditConnection }
        />
      </BootstrapCard>
    );
  }
}

ConnectionsOperations.propTypes = {
  fetchingConnections: PropTypes.bool,
  connections: PropTypes.arrayOf(PropTypes.object).isRequired,
  connectionsActions: PropTypes.shape({
    fetchConnections: PropTypes.func,
    fetchConnection: PropTypes.func
  }).isRequired,
  handleNewButton: PropTypes.func.isRequired
};

ConnectionsOperations.defaultProps = {
  fetchingConnections: false
};

export default ConnectionsOperations;



// WEBPACK FOOTER //
// ./src/components/manageConnection/comp/connectionsOperations/ConnectionsOperations.js